export enum FulfilmentType {
  PICKUP = 'Pickup',
  DELIVERY = 'Delivery',
  DINE_IN = 'Dine In',
}
